module.exports = __webpack_public_path__ + "img/2-14-7.339b1b4c.png";